import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import "./Banner.scss";

interface IProps {
    id: string;
    title: string;
    description: string;
    hideTranslation?: boolean;
    children?: ReactNode;
}

const Banner = (props: IProps) => {
    const { t } = useTranslation();

    return (
        <div id={props.id + "-banner"} className="userful-special-banner-wrapper">
            <div className="userful-special-banner-text-wrapper">
                <h1>{props.hideTranslation ? props.title : t(props.title)}</h1>
                <p>{props.hideTranslation ? props.description : t(props.description)}</p>
            </div>
            {props.children && <div className="userful-special-banner-body">{props.children}</div>}
        </div>
    );
};
export default Banner;
